<div *ngIf="!isNavigate" class="selected-box gbo_shadow">
    <h3>{{ 'TASKS.TEXT.OBJECT_INFO' | translate }}</h3>
    <div *ngIf="!selectTask">
        <i>{{ 'TASKS.TEXT.NOT_SELECTED' | translate }}</i>
    </div>
    <div *ngIf="selectTask" class="selected-item">
        <div class="icon">
            <i class="icon-folder"></i>
        </div>
        <div>
            <strong>#{{ 1 }}. {{ selectTask.title }}</strong>
            <div [innerHtml]="selectTask.content" style="word-break: break-word;"></div>
            <button (click)="submitItem()" class="btn btn-primary position-sticky" data-action='submitItem'
                    style="left: 90%;">
                {{ 'MODALS.BUTTONS.SELECT' | translate }}
            </button>
        </div>
    </div>
</div>

<app-component-button-create-task (eminOnCreateTask)="loadTasks(!!this.alias, true)"
                                  *ngIf="!isNavigate"
></app-component-button-create-task>

<div *ngIf="parentTaskAlias && !isSubtasks && !loading">
    <input #searchingText (input)="sortTasks(searchingText.value)" class="form-control form-control-sm"
           placeholder="{{ 'BUTTON_TEXT.SEARCH' | translate }}"
           style="width: 25%; display: inline;"
           type="text">
</div>

<div *ngIf="searchType === 'my'" class="mb-1">
    <strong class="me-1">{{ 'TASKS.TEXT.ROLE' | translate }}</strong>
    <span (click)="onChangeSort(iAm)"
          *ngFor="let iAm of filter.roles"
          [attr.data-me]="iAm.value"
          class="badge badge-pill me-1 mt-1 {{iAm.isSelected ? 'text-bg-info' : 'text-bg-light'}}"
          data-action='sortByPosition'
          style="cursor: pointer;"
    >
        {{ 'TASKS.TEXT.ROLES.' + iAm.value | translate }}
    </span>

    <span #filterButtonShowContainer
          class="badge badge-pill me-1 mt-1 {{!filter.more ? 'text-bg-light' : 'text-bg-success'}}"
          ngbTooltip="{{ 'TASKS.TOOLTIPS.DETAIL_FILTER' | translate }}"
          style="cursor: pointer;"
    >
       {{ 'TASKS.TEXT.DETAIL_FILTER' | translate }} <i class="bi bi-filter-circle"></i>
    </span>

    <div #filterContainer *ngIf="filter.more" class="filter-container gbo_shadow">
        <div class="mt-1">
            <strong class="me-1">{{ 'TASKS.TEXT.BOARD' | translate }}</strong>
            <span (click)="getDetailBoardForFilter(board)"
                  *ngFor="let board of allBoardsForFilter"
                  class="badge badge-pill me-1 {{!(selectedBoardForFilter &&
                  selectedBoardForFilter.alias === board.alias) ? 'text-bg-light' : 'text-bg-info'}}"
                  style="cursor: pointer;"
            >
                {{ board.name }}
        </span>
        </div>

        <div *ngIf="selectedBoardForFilter" class="mt-1">
            <strong class="me-1">{{ 'TASKS.TEXT.STATUSES' | translate }}</strong>
            <span (click)="checkStatusId(status)"
                  *ngFor="let status of selectedBoardForFilter.status_node_settings_of_member"
                  class="badge badge-pill {{!selectedStatusesIds.includes(status.status_node.id) ?
                        'text-bg-light' : 'text-bg-info'}}"
                  style="cursor: pointer;"
            >
                {{ status.status_node.label }}
            </span>
        </div>

        <button (click)="refreshTasksWithSort()" *ngIf="selectedBoardForFilter" class="btn btn-sm btn-success mt-1">
            {{ 'TASKS.BUTTONS.APPLY' | translate }}
        </button>
        <button (click)="clearFilter()" *ngIf="selectedBoardForFilter || isFilterUsed"
                class="btn btn-sm btn-danger mt-1 ms-1">
            {{ 'TASKS.BUTTONS.RESET' | translate }}
        </button>
    </div>

    <div *ngIf="selectedBoardForFilter" class="mt-2">
        <strong class="me-1">{{ 'TASKS.TEXT.BOARD' | translate }}</strong>
        <span class="badge badge-pill me-1 mt-1 text-bg-info" style="cursor: default;">
            {{ selectedBoardForFilter.name }}
        </span>
        <span (click)="clearFilter()" class="badge badge-pill me-1 mt-1 text-bg-danger" style="cursor: pointer;">
            {{ 'TASKS.BUTTONS.RESET' | translate }}
        </span>
        <br>

        <strong class="me-1">{{ 'TASKS.TEXT.STATUSES' | translate }}</strong>
        <span (click)="checkStatusId(status, true)"
              *ngFor="let status of selectedBoardForFilter.status_node_settings_of_member"
              class="badge badge-pill {{!selectedStatusesIds.includes(status.status_node.id) ?
              'text-bg-light' : 'text-bg-info'}}"
              style="cursor: pointer;"
        >
            {{ status.status_node.label }}
        </span>
    </div>
</div>
<div [class.big]="isMini === false"
     [class.minimized]="isMini === true"
>
    <table class="table default-table gbo_shadow" style="width: max-content;">
        <thead>
        <th *ngIf="parentTaskAlias"></th>

        <th *ngFor="let colon of colons; let i = index; trackBy: trackByKey"
            style="text-align: center;"
        >
            <div (click)="sortBy(colon.alias)"
                 [class.revers]="pagination.sort === 'asc' && pagination.sort_by === colon.alias"
                 [class.sorting]="pagination.sort_by === 'importance_index'"
                 data-action='sortByImportanceIndex'
            >
                <i *ngIf="colon.model"
                   [class]="propertyIcon[colon.model.property_type].icon"
                   ngbTooltip="{{'PROPERTIES.TOOLTIPS.' + propertyIcon[colon.model.property_type].tooltip | translate}}"
                ></i>

                <span [class.text-primary]="!['roles', 'user_roles', 'task_board_name', 'task_type']
                                            .includes(colon.alias)"
                      [ngStyle]="!['roles', 'user_roles', 'task_board_name', 'task_type'].includes(colon.alias) ?
                                {cursor: 'pointer'} : {cursor: 'default'}"
                >
                    {{ colon.model ? colon.model.title : 'TASKS.TITLES.' + colon.alias | translate }}
                </span>

                <i *ngIf="pagination.sort_by === colon.alias"
                   [class.icon-down-1]="pagination.sort === 'asc'"
                   [class.icon-up-1]="pagination.sort !== 'asc'"
                ></i>
            </div>
        </th>
        </thead>

        <ng-container *ngIf="loading">
            <tr>
                <td [attr.colspan]="(searchType === 'my') ? colons.length + 1 : colons.length" class="text-center">
                    <app-component-loading></app-component-loading>
                </td>
            </tr>
        </ng-container>

        <tbody *ngIf="!loading">
        <ng-container *ngIf="tasks && !tasks.length">
            <tr>
                <td [attr.colspan]="(searchType === 'my') ? colons.length + 1 : colons.length" class="text-center">
                    <b>{{ 'EMPTY_LISTS.TASKS' | translate }}</b>
                </td>
            </tr>
        </ng-container>
        <ng-container *ngFor="let item of tasks; let i = index; trackBy: trackByAlias">
            <tr (click)="changeTask(item, false)"
                (dblclick)="changeTask(item, true)"
                [class]="getTrClass(item)"
            >
                <td *ngIf="parentTaskAlias">
                    <div (click)="deleteTaskFormSubtasks(item.task_alias)" *ngIf="!subtasks && !item.isParentSubtask"
                         style="cursor: pointer;">
                        <i class="bi bi-trash" style="color: red; font-size: 18px;"></i>
                    </div>
                </td>

                <td *ngFor="let col of colons; let i = index; trackBy: trackByKey"
                    [class.disabled-td]="col.model && (item.custom_properties[col.alias] === undefined)"
                    [ngStyle]="{'background-color': (col.alias === 'status_current' ?
                                                    item[col.alias].data.backgrCol : '')}"
                    style="text-align: center;"
                >
                    <!--          Даты          -->
                    <span *ngIf="['deadline_at', 'created_at', 'status_at', 'updated_at', 'due_time']
                                    .includes(col.alias)">
                        {{ item[col.alias] ? helper.formatDate(item[col.alias]) : '-' }}
                    </span>

                    <!--          Переключение доски          -->
                    <span (click)="openBoard($event, item)"
                          *ngIf="col.alias=== 'task_board_name'"
                          class="user_name"
                    >
                        {{ item[col.alias] }}
                    </span>

                    <!--         Статус задачи           -->
                    <span *ngIf="col.alias=== 'status_current'">
                        <i [class]="item[col.alias].data.svg.class"></i> {{ item[col.alias].label }}
                    </span>

                    <!--          Важность задачи          -->
                    <span *ngIf="col.alias=== 'importance'">
                        {{ 'TASKS.TEXT.IMPORTANCE.' + item[col.alias] | translate }}
                    </span>

                    <!--          Тип задачи          -->
                    <span *ngIf="col.alias=== 'task_type'">
                        <i [class]="item[col.alias].icon"></i> {{ item[col.alias].name }}
                    </span>

                    <!--          Комментарии          -->
                    <span *ngIf="col.alias=== 'comments_count'">
                        {{ item[col.alias] }}
                    </span>

                    <!--          Контракт          -->
                    <span *ngIf="col.alias=== 'contract_guid'">
                        {{ !item[col.alias] ? '-' : 'TASKS.TEXT.CONTRACT' | translate }}
                    </span>

                    <!--          Продолжительность          -->
                    <span *ngIf="col.alias=== 'duration'">
                        {{ item[col.alias] ? helper.getTimeFromMinute(item[col.alias]) : '-' }}
                    </span>

                    <!--          Алиас задачи          -->
                    <span *ngIf="col.alias=== 'task_alias'">
                        #{{ item[col.alias] }}
                    </span>

                    <!--         Описание           -->
                    <div *ngIf="col.alias === 'content'"
                         [innerHTML]="item.content ? item.content : '-'"
                         class="short_content"
                    ></div>

                    <!--          Название          -->
                    <div *ngIf="col.alias === 'title'"
                         [ngbTooltip]="item.title"
                         class="short_name"
                    >
                        {{ item.title }}
                    </div>

                    <!--         Роли текущего пользователя в задаче           -->
                    <div *ngIf="col.alias=== 'user_roles'">
                        <span *ngIf="item[col.alias].length">
                            <span *ngFor="let role of item[col.alias]">
                                {{ 'TASKS.TEXT.TASK_ROLES.' + role | translate }}
                                <br></span>
                        </span>
                        <span *ngIf="!item[col.alias].length">-</span>
                    </div>

                    <!--         Роли пользователей           -->
                    <span *ngIf="col.alias=== 'roles' && membersComplete">
                        <span *ngIf="item[col.alias].executor.length"> {{ 'TASKS.DETAIL.TEXT.EXECUTORS' | translate }}:
                            <br></span>
                        <span (click)="openProfile($event, user.memberModel)"
                              *ngFor="let user of item[col.alias].executor"
                              [class.blocked_user]="user.memberModel.project_setting.observation_type === 'blocked'"
                              [class.inactive_user]="!user.memberModel.is_active"
                              class="user_name"
                        >
                            <img *ngIf="user.memberModel.project_setting.is_project_admin"
                                 alt="#"
                                 height="16" ngSrc="../../../assets/images/admin.svg"
                                 ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}" width="16">
                            {{ helper.shortFullName(user.memberModel) }} <br>
                        </span>

                        <span *ngIf="item[col.alias].responsible.length">
                            {{ 'TASKS.DETAIL.TEXT.RESPONSIBLE' | translate }}: <br>
                        </span>
                        <span (click)="openProfile($event, user.memberModel)"
                              *ngFor="let user of item[col.alias].responsible"
                              [class.blocked_user]="user.memberModel.project_setting.observation_type === 'blocked'"
                              [class.inactive_user]="!user.memberModel.is_active"
                              class="user_name"
                        >
                            <img *ngIf="user.memberModel.project_setting.is_project_admin"
                                 alt="#"
                                 height="16" ngSrc="../../../assets/images/admin.svg"
                                 ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}" width="16">
                            {{ helper.shortFullName(user.memberModel) }} <br>
                        </span>

                        <span *ngIf="!item[col.alias].responsible.length && !item[col.alias].executor.length"> - </span>
                    </span>

                    <!--          Индекс приоритета          -->
                    <div *ngIf="col.alias === 'importance_index'">
                        <strong *ngIf="!!parentTaskAlias || isSubtasks || !isNavigate || personGuid">
                            {{ item.importance_index }}
                        </strong>

                        <app-select (selectEmit)="editImportanceIndex(item, $event)"
                                    *ngIf="!(!!parentTaskAlias || isSubtasks || !isNavigate || personGuid)"
                                    [data]="boardRangeIndex ? boardRangeIndex : item.importance_indexes"
                                    [needConvert]="true"
                                    [selected]="item.importance_index"
                        ></app-select>
                    </div>

                    <!--          Отображение проперти          -->
                    <span *ngIf="col.model && (item.custom_properties[col.alias] !== undefined)">
                        <ng-container
                                *ngTemplateOutlet="propTemplates;
                                context: {props: col.model, value: item.custom_properties[col.alias]}"
                        >
                        </ng-container>
                    </span>

                    <!--         остальное           -->
                    <span *ngIf="!['deadline_at',
                                    'created_at',
                                    'status_at',
                                    'updated_at',
                                    'task_board_name',
                                    'status_current',
                                    'task_type',
                                    'comments_count',
                                    'contract_guid',
                                    'importance',
                                    'due_time',
                                    'duration',
                                    'task_alias',
                                    'content',
                                    'title',
                                    'roles',
                                    'importance_index',
                                    'user_roles'
                                   ].includes(col.alias) && !col.model"
                    >
                        {{ item[col.alias] ? item[col.alias] : '-' }}
                    </span>
                </td>
            </tr>

            <tr *ngIf="selectTask && selectTask.task_alias === item.task_alias" class="desc">
                <td [attr.colspan]="(searchType === 'my') ? colons.length + 1 : colons.length"
                    style="background: white;">
                    <div [innerHtml]="selectTask.content" style="max-width: 1000px;"></div>

                    <button (click)="changeTask(item, true)" [attr.data-index]="i"
                            class="btn btn-link" data-action='openTaskByButton'> {{ 'TASKS.TEXT.DETAIL' | translate }}
                    </button>
                </td>
            </tr>
        </ng-container>
        </tbody>
    </table>
</div>
<div *ngIf="tasks && (!isSubtasks || tasks.length === pagination.limit)"
     style="padding-left: 5px; padding-bottom: 15px;">
    <app-component-pagination (page)="changePage($event)"
                              [pagination]="pagination"></app-component-pagination>
</div>
<ng-template #viewTaskView let-modal>
    <app-button-modal-close [modal]="modal" modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <app-component-task-detail
                (emitOnDelete)="$event ? taskWillBeDeleted(modal) : null"
                (emitUpdateStatus)="loadTasks()"
                (emitUpdateTask)="loadTasks(false, true)"
                [taskAlias]="selectTask.task_alias"
        ></app-component-task-detail>
    </div>
</ng-template>

<ng-template #propTemplates let-props="props" let-value="value">
    <ng-container [ngSwitch]="props.property_type">
        <ng-template ngSwitchCase="property_file">
            <div *ngIf="props.is_multiform ? value.length : value; else emptyTemplate">
                <div *ngIf="props.is_multiform">
					<span *ngFor="let val of value; let i = index">
						<span *ngIf="i !== 0" class="me-1">,</span>
                        {{ val.name }}
					</span>
                </div>
                <div *ngIf="!props.is_multiform">
					<span>
						{{ value.name }}
					</span>
                </div>
            </div>
        </ng-template>

        <ng-template ngSwitchCase="property_member">
            <div *ngIf="props.is_multiform ? value.length : value; else emptyTemplate">
                <div *ngIf="props.is_multiform">
					<span *ngFor="let val of value; let i = index">
						<span *ngIf="i !== 0" class="me-1">,</span>
							<span (click)="openProfile($event, val)" class="user_name">
								{{ helper.fullName(val) }}
							</span>
					</span>
                </div>
                <div *ngIf="!props.is_multiform">
					<span (click)="openProfile($event, value)" class="user_name">
						{{ helper.fullName(value) }}
					</span>
                </div>
            </div>
        </ng-template>

        <ng-template ngSwitchCase="property_text">
            <div>
                <span *ngIf="value; else emptyTemplate">{{ value }}</span>
            </div>
        </ng-template>

        <ng-template ngSwitchCase="property_boolean">
            <div *ngIf="value; else emptyTemplate">
                <span>{{ 'PROPERTIES.VALUES.' + value ? 'TRUE' : 'FALSE' | translate }}</span>
            </div>
        </ng-template>

        <ng-template ngSwitchCase="property_catalog">
            <div *ngIf="props.is_multiform ? value.length : value; else emptyTemplate">
                <div *ngIf="props.is_multiform">
					<span *ngFor="let val of value; let i = index">
						<span *ngIf="i !== 0" class="me-1">,</span>
                        {{ val.items_text }}
					</span>
                </div>
                <div *ngIf="!props.is_multiform">
					<span>
						{{ value.items_text }}
					</span>
                </div>
            </div>
        </ng-template>

        <ng-template ngSwitchCase="property_todo">
            <div *ngIf="value.length; else emptyTemplate">
                <div *ngFor="let checkedItem of value">
                    <span>
                        <i class="bi bi-check-square text-success"></i>
                        {{ checkedItem.items_text }}
                    </span>
                </div>
            </div>
        </ng-template>

        <ng-template #emptyTemplate>
            <span>{{ 'PROPERTIES.VALUES.EMPTY' | translate }}</span>
        </ng-template>
    </ng-container>
</ng-template>
